import { render, staticRenderFns } from "./panel-video.vue?vue&type=template&id=a1e7c6b4&"
import script from "./panel-video.vue?vue&type=script&lang=js&"
export * from "./panel-video.vue?vue&type=script&lang=js&"
import style0 from "./panel-video.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports